import { BlocksIconBrowserMultipleWindow } from 'blocks-nextjs/blocks-web-components/components/icon/icons/browser-multiple-window';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconBrowserMultipleWindow = createComponent({
  react: React,
  tagName: 'cat-icon-browser-multiple-window',
  elementClass: BlocksIconBrowserMultipleWindow
});
